import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomainDto } from '@picflow/types';
import { lastValueFrom } from 'rxjs';
import { AppConfigService } from '../providers/config.service';
import { DataLoaderService } from './data-loader.service';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root',
})
export class CustomDomainService {
  constructor(
    private http: HttpClient,
    private config: AppConfigService,
    private permisionService: PermissionService,
    private loader: DataLoaderService
  ) {}

  async getCustomDomain(): Promise<DomainDto> {
    if (!this.permisionService.canDisplayElement('tenant.customDomain', undefined)) return;
    return this.loader.get('custom-domains', async () => {
      try {
        const resp = await lastValueFrom(this.http.get<{ data: DomainDto[] }>(`${this.config.apiEndpoint}/domains`));
        return resp.data[0] ?? null;
      } catch (err) {
        console.log(err);
      }
    });
  }

  async removeCustomDomain(id: string) {
    this.loader.remove('custom-domains');
    return await lastValueFrom(this.http.delete(`${this.config.apiEndpoint}/domains/${id}`));
  }

  normalizeDomain(domain: string) {
    return domain.split('https//').join('').split('http//').join('').split('www.').join('').toLowerCase();
  }

  async addCustomDomain(customDomain: string) {
    const domain = this.normalizeDomain(customDomain);
    const isApex = domain.split('.').length === 2;
    this.loader.remove('custom-domains');
    try {
      return await lastValueFrom(
        this.http.post(`${this.config.apiEndpoint}/domains`, { domain, type: isApex ? 'apex' : 'subdomain' })
      );
    } catch (err) {
      console.error(err);
    }
  }

  async checkDomain(id: string) {
    try {
      this.loader.remove('custom-domains');
      return await lastValueFrom(
        this.http.post<{ status: string }>(`${this.config.apiEndpoint}/domains/${id}/check`, {})
      );
    } catch (err) {
      console.error(err);
      return;
    }
  }
}
